import { FC, ReactNode } from "react";
import { Flex } from "@chakra-ui/react";

interface Props {
  children: ReactNode;
}

export const StepContainer: FC<Props> = ({ children }) => {
  return (
    <Flex
      bg="th.cream1"
      border="1px solid"
      borderColor="th.cream3"
      borderRadius="lg"
      direction="column"
      maxW="19.125rem"
      position="relative"
      px={8}
      py={6}
      textAlign="center"
      w="full"
    >
      {children}
    </Flex>
  );
};
